var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.98291,
    y: 0.623932,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#4B00A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1539 20.9149C31.1539 23.5897 30.0913 26.155 28.1999 28.0464C26.3085 29.9378 23.7432 31.0004 21.0684 31.0004C18.3936 31.0004 15.8283 29.9378 13.9369 28.0464C12.0455 26.155 10.9829 23.5897 10.9829 20.9149M31.1539 20.9149C31.1539 18.2401 30.0913 15.6748 28.1999 13.7834C26.3085 11.892 23.7432 10.8294 21.0684 10.8294C18.3936 10.8294 15.8283 11.892 13.9369 13.7834C12.0455 15.6748 10.9829 18.2401 10.9829 20.9149M31.1539 20.9149H10.9829",
    stroke: "white",
    strokeWidth: 1.55161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9474 20.9149C24.7569 24.6031 23.3984 28.1351 21.0684 31.0004C18.7384 28.1351 17.3799 24.6031 17.1894 20.9149C17.3799 17.2267 18.7384 13.6947 21.0684 10.8294C23.3984 13.6947 24.7569 17.2267 24.9474 20.9149Z",
    stroke: "white",
    strokeWidth: 1.55161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetIcon);
export default __webpack_public_path__ + "static/media/Internet Icon.c9fd4fa75938ad36c95be544576396dc.svg";
export { ForwardRef as ReactComponent };